import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { PaginationItem } from '../types'
import { useFindLocaleText } from '../../../../text-localisation'
import { PageButton } from './PageButton'
import { Ellipsis } from './Ellipsis'

const StyledPageButtons = styled.ol`
  ${s({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 3,
  })}
`

type PageButtonsProps = {
  items: PaginationItem[]
  currentPage: number
  onClick: (event: React.MouseEvent<HTMLElement>, page: number) => void
  getPageHref: (page: number) => string
}

const renderPaginationItem = (
  item: PaginationItem,
  props: Omit<PageButtonsProps, 'items'> & {
    localiseText: ReturnType<typeof useFindLocaleText>
  },
) => {
  const { currentPage, onClick, getPageHref, localiseText } = props

  if (item.type === 'ellipsis') {
    return (
      <Ellipsis
        key={item.key}
        itemKey={item.key}
        condensedViewOnly={item.condensedViewOnly}
      />
    )
  }

  return (
    <PageButton
      key={item.page}
      page={item.page}
      currentPage={currentPage}
      hiddenInCondensedView={item.hiddenInCondensedView}
      onClick={onClick}
      getPageHref={getPageHref}
      localiseText={localiseText}
    />
  )
}

export const PageButtons: FC<PageButtonsProps> = ({
  items,
  currentPage,
  onClick,
  getPageHref,
}) => {
  const localiseText = useFindLocaleText()

  return (
    <StyledPageButtons>
      {items.map(item =>
        renderPaginationItem(item, {
          currentPage,
          onClick,
          getPageHref,
          localiseText,
        }),
      )}
    </StyledPageButtons>
  )
}
